<template>
  <div id="qualified-year-statistics" style="height: 210px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        title: { show: false },
        legend: {
          data: [
            { name: '合格数', color: '#aeeff0' },
            { name: '检测数', color: '#f1829f' },
          ],
          textStyle: { fill: '#9cd9fc' },
          top: 15,
          right: 0,
        },
        grid: { left: 0, right: 0, top: 0, bottom: 40 },
        xAxis: {
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisLabel: {
            formatter: '{value}月',
            style: { fill: '#9cd9fc' },
          },
        },
        yAxis: [
          {
            name: '合格数',
            data: 'value',
            axisLine: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
            splitLine: {
              style: { stroke: '#3f3f3f' },
            },
          },
          {
            name: '检测数',
            data: 'value',
            position: 'right',
            axisLine: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
          },
        ],
        series: [
          {
            name: '检测数',
            data: [
              2906,
              4458,
              8027,
              7169,
              5226,
              6501,
              4893,
              null,
              null,
              589,
              4054,
              5533,
            ],
            type: 'line',
            smooth: true,
            lineArea: {
              show: false,
              gradient: ['rgba(251, 114, 147, 1)', 'rgba(251, 114, 147, 0)'],
            },
            lineStyle: {
              stroke: 'rgba(251, 114, 147, 1)',
            },
            linePoint: {
              style: {
                stroke: 'rgba(251, 114, 147, 1)',
              },
            },
            label: { show: true, style: { fill: 'rgba(251, 114, 147, 1)' } },
            yAxisIndex: 1,
          },
          {
            name: '合格数',
            data: [
              2883,
              4417,
              7964,
              7113,
              5208,
              6456,
              4922,
              null,
              null,
              588,
              4013,
              5507,
            ],
            type: 'bar',
            gradient: {
              color: ['rgba(103, 224, 227, .6)', 'rgba(103, 224, 227, .1)'],
            },
            barStyle: {
              stroke: 'rgba(103, 224, 227, 1)',
            },
            label: {
              show: true,
              style: { fill: 'rgba(153, 227, 244,1)' },
              position: 'bottom',
              offset: [0, -5],
            },
          },
        ],
      },
    }
  },
  mounted() {
    const container = document.getElementById('qualified-year-statistics')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/quality-zone/qualified-year-statistics.vue